// extracted by mini-css-extract-plugin
export var box_shadow = "index-module--box_shadow--f6e6d";
export var cancel = "index-module--cancel--9898f";
export var expand_content = "index-module--expand_content--5aadb";
export var header = "index-module--header--52ad0";
export var logo = "index-module--logo--b1f41";
export var menu = "index-module--menu--86bb5";
export var mobile_header = "index-module--mobile_header--73d0c";
export var wrap = "index-module--wrap--f8408";